// Initialize theme object
window.theme = window.theme || {};

import '../scripts/utils/helpers/lazy-media.js';

// Dispatch event when theme bundle is loaded
document.dispatchEvent(new CustomEvent('theme:loaded'));
window.theme.loaded = true;
